import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./assets/style/reset.less?vue&type=style&index=0&lang=less&external"

const __exports__ = script;

export default __exports__